import { gql } from '@apollo/client';
import fdaPracticeAreaFragment from './fdaPracticeAreaFragment';

const GET_FDA_CONTRACT_TOTAL_REPORT = gql`
  query GetFdaContractTotalReport($ohts: [Int!], $orgId: Int) {
    fdaContractTotalReport(ohts: $ohts, orgId: $orgId) {
      ...FdaPracticeAreaFragment
    }
  }

  ${fdaPracticeAreaFragment}
`;

export default GET_FDA_CONTRACT_TOTAL_REPORT;
